import React from 'react';
import { branding } from 'stripes-config';
import { PreLoginLogoBanner } from '../Recek/TestVersionBanner';
import styles from './OrganizationLogo.css';

const OrganizationLogo = () => {
  return (
    branding &&
      <>
        <div className={styles.logo}>
          <img
            alt={branding.logo.alt}
            src={branding.logo.src}
          />
        </div>
        {/* ReČeK: on test instances the warning banner sits between the logo and the form */}
        <PreLoginLogoBanner />
      </>
  );
};

export default OrganizationLogo;
